import { type ReactElement, useState } from "react";
import { useTranslation } from "react-i18next";
import PackBrowserModal from "./PackBrowserModal.js";

interface Props {
  tableId: string;
  uid: string | undefined;
  guildId: string | undefined;
  currentRulesetId: string | null;
  currentRulesetVersion: string | null;
  onNext: () => void;
}

export default function WizardRulesetStep(props: Props): ReactElement {
  const { t } = useTranslation();
  const [browserOpen, setBrowserOpen] = useState(false);

  return (
    <section className="space-y-3">
      <h3 className="text-base font-semibold">{t("wizard.ruleset.title")}</h3>
      <p className="text-sm text-muted-foreground">{t("wizard.ruleset.desc")}</p>

      <div className="rounded border p-3 text-sm">
        {props.currentRulesetId ? (
          <div>
            <div className="font-medium">{props.currentRulesetId}</div>
            <div className="text-xs text-muted-foreground">v{props.currentRulesetVersion}</div>
          </div>
        ) : (
          <div className="italic text-muted-foreground">{t("wizard.ruleset.none")}</div>
        )}
      </div>

      <div className="flex gap-2">
        <button
          type="button"
          className="rounded border px-3 py-1 text-sm"
          onClick={() => setBrowserOpen(true)}
        >
          {t("wizard.ruleset.browse")}
        </button>
        <button
          type="button"
          className="rounded bg-emerald-600 px-3 py-1 text-sm text-white disabled:opacity-50"
          disabled={!props.currentRulesetId}
          onClick={props.onNext}
        >
          {t("wizard.next")}
        </button>
      </div>

      <PackBrowserModal
        open={browserOpen}
        tableId={props.tableId}
        packKind="ruleset"
        guildId={props.guildId}
        uid={props.uid}
        installedIds={new Set(props.currentRulesetId ? [props.currentRulesetId] : [])}
        onClose={() => setBrowserOpen(false)}
      />
    </section>
  );
}
